<template>
  <div
    class="add-coverage-block d-flex align-content-between flex-wrap"
    v-bind:class="{
      selected: value.selected ? true : false,
      disabled: disabled
    }"
  >
    <div class="d-flex w-100">
      <div class="add-coverage-title">
        <span class="title" v-dompurify-html="title"></span>
        <span class="ml-2 sub-title" v-if="value.selected ? true : false"
          >Premio
          {{
            valueToPay
              | currency({
                symbol: "€",
                thousandsSeparator: ".",
                fractionCount: 0,
                fractionSeparator: ",",
                symbolPosition: "",
                symbolSpacing: true
              })
          }}</span
        >
      </div>
      <div
        v-if="!disabled"
        @click="updateModel(!value.selected, currencyValue)"
        class="select-icon ml-auto ml-1"
      >
        <img
          alt="Aggiungi"
          src="../assets/images/add.svg"
          v-if="!value.selected"
        />
        <img
          alt="Rimuovi"
          src="../assets/images/remove.svg"
          v-if="value.selected"
        />
      </div>
    </div>
    <div class="mr-auto ml-auto" v-if="value.selected">
      <currency-spinner
        v-model="currencyValue"
        :list-values="listValues"
        :max-value="maxValue"
        :description="currencyValueDescription"
      ></currency-spinner>
    </div>
    <div class="coverage-not-available" v-if="disabled">
      Non disponibile
    </div>
  </div>
</template>

<script>
import CurrencySpinner from "./CurrencySpinner";
export default {
  name: "AddCoverageSelector",
  components: { CurrencySpinner },
  props: {
    title: String,
    value: Object,
    multiplier: String,
    maxValue: Number,
    sumAllCoverage: Number,
    listValues: Array,
    disabled: Boolean
  },
  data: () => {
    return {
      currencyValueDescription: "Copertura assicurartiva",
      currencyValue: 0,
      valueToPay: 0
    };
  },
  mounted() {
    this.selected = this.value.selected;
    this.currencyValue = this.value.value;
  },
  watch: {
    currencyValue(after) {
      let newVal = after;
      // console.log("cmp", this.sumAllCoverage > this.maxValue);
      // if ((this.sumAllCoverage - before + after) > this.maxValue) {
      //     // const currIndex = this.listValues.indexOf(newVal);
      //     newVal = before;
      //     // newVal -= this.currencyStep;
      // }
      // this.currencyValue = newVal;
      this.updateModel(this.value.selected, newVal);
    }
  },
  methods: {
    updateModel(selected, value) {
      if (value <= this.maxValue) {
        if (!this.value.selected) {
          value = this.listValues[0];
          this.currencyValue = value;
        }
        this.valueToPay = Number(this.multiplier) * value;
      } else {
        selected = false;
      }
      // if (this.getSingleMaxValue(value) > 0) {
      //   if (!this.value.selected) {
      //     value = this.listValues[0];
      //     this.currencyValue = value;
      //   }
      //   this.valueToPay = Number(this.multiplier) * value;
      // } else {
      //   selected = false;
      // }
      this.$emit("input", {
        selected,
        value
      });
    },
    getSingleMaxValue(currValue) {
      return this.value.selected
        ? this.maxValue - this.sumAllCoverage + currValue
        : this.maxValue - this.sumAllCoverage;
    }
  }
};
</script>

<style scoped></style>
